<form autocomplete="off">
  <mat-form-field>
    <mat-label>Breed</mat-label>
    <input matInput spellcheck="false" [formControl]="input" [matAutocomplete]="auto">
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" [autoActiveFirstOption]="true">
    <mat-option class="option-suffix-icon" *ngFor="let breed of filteredBreeds$ | async" [value]="breed">
      {{ breed.name | titlecase }}
      <mat-icon *ngIf="!breed.default" (click)="removeBreed(breed); $event.stopPropagation()">close</mat-icon>
    </mat-option>
    <mat-option *ngIf="showAddBreed$ | async" [value]="input.value" (click)="addBreed(input.value)">
      Add <b>{{ (input.value?.name ? input.value.name : input.value) | titlecase }}</b> to breeds
    </mat-option>
  </mat-autocomplete>
</form>
<mat-chip-list>
  <mat-chip *ngFor="let breed of breeds$ | async"
    [selected]="isSelected(breed)"
    (tap)="onChipTap(breed, $event)"
    (press)="onChipPress(breed)"
    (blur)="showRemove$.next(null)">
    {{ breed.name | titlecase }}
    <mat-icon matChipRemove *ngIf="showRemove(breed)" (click)="removeBreed(breed)">cancel</mat-icon>
  </mat-chip>
</mat-chip-list>